import { Injectable } from '@angular/core';
import {
  NgbDateParserFormatter,
  NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap';

const dateRegex =
  /^([1-9]|0[1-9]|[12][0-9]|3[01])\.([1-9]|0[1-9]|1[0-2])\.(\d{4})$/;

@Injectable({ providedIn: 'root' })
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '.';

  parse(value: string): NgbDateStruct | null {
    if (value && dateRegex.test(value)) {
      const [day, month, year] = value.split(this.DELIMITER);
      return {
        day: parseInt(day, 10),
        month: parseInt(month, 10),
        year: parseInt(year, 10),
      };
    }

    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date
      ? String(date.day).padStart(2, '0') +
          this.DELIMITER +
          String(date.month).padStart(2, '0') +
          this.DELIMITER +
          date.year
      : '';
  }
}
